__turbopack_context__.v({
  "bellWrapper": "DesktopHeader-module__l14iKq__bellWrapper",
  "disabled": "DesktopHeader-module__l14iKq__disabled",
  "link": "DesktopHeader-module__l14iKq__link",
  "navScroll": "DesktopHeader-module__l14iKq__navScroll",
  "navbarMain": "DesktopHeader-module__l14iKq__navbarMain",
});
